import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/** Model-agnostic debug viewer: dumps any front-end model as formatted JSON. */
export interface LeapV2DebugDialogData {
  title: string;
  model: unknown;
}

@Component({
  selector: 'leap-v2-debug-dialog',
  templateUrl: './leap-v2-debug-dialog.component.html',
  styleUrls: ['./leap-v2-debug-dialog.component.css'],
  standalone: false,
})
export class LeapV2DebugDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<LeapV2DebugDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LeapV2DebugDialogData
  ) {}
}
